import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'

export function OnboardingLecturaFallida({onRetry}: {onRetry: () => void}) {
  const {t} = useTranslation()
  return (
    <div
      className="surface flex flex-col items-center gap-3 px-6 py-10 text-center"
      data-testid="onboarding-lectura-fallida">
      <p className="text-sm text-foreground">{t('ficha.onboardingErrorTitle')}</p>
      <Button size="sm" variant="outline" onClick={onRetry}>
        {t('ficha.onboardingErrorRetry')}
      </Button>
    </div>
  )
}
